export const isGiftCard = (item) => Object.prototype.hasOwnProperty.call(item.properties, "_gc_item");
